import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "steriltron-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 inset-x-4 md:bottom-6 md:right-6 md:left-auto md:max-w-md z-[60]"
        >
          <div className="bg-white border border-slate-200 shadow-xl">
            <div className="h-1 bg-brand-800" />
            <div className="p-6 md:p-7">
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 bg-brand-50 text-brand-800 flex items-center justify-center flex-shrink-0">
                  <Cookie size={18} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold tracking-tight text-brand-950">We value your privacy</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    We use cookies to ensure the website functions correctly and, with your consent,
                    to understand how it is used. See our{" "}
                    <Link to="/cookies" data-testid="cookie-policy-link" className="text-brand-800 underline underline-offset-2 hover:text-brand-900">Cookie Policy</Link>.
                  </p>
                </div>
              </div>
              <div className="mt-5 flex flex-col sm:flex-row gap-3">
                <button
                  data-testid="cookie-accept"
                  onClick={() => decide("accepted")}
                  className="flex-1 bg-brand-800 text-white px-5 py-3 text-xs font-semibold uppercase tracking-wider hover:bg-brand-900 transition-colors active:scale-[0.98]"
                >
                  Accept All
                </button>
                <button
                  data-testid="cookie-decline"
                  onClick={() => decide("declined")}
                  className="flex-1 border border-slate-300 text-slate-700 px-5 py-3 text-xs font-semibold uppercase tracking-wider hover:border-brand-800 hover:text-brand-800 transition-colors active:scale-[0.98]"
                >
                  Essential Only
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
